export const ONBOARDING_GOAL_LABELS = {
  lose_weight: 'Lose Weight 🔥',
  build_muscle: 'Build Muscle 💪',
  consistency: 'Build an Exercise Habit 🔥',
  strength: 'Get Stronger 💪',
  endurance: 'Improve Endurance 🏃',
  stress: 'Reduce Stress 🧘',
  energy: 'Boost Energy ⚡',
  wellbeing: 'Feel Healthier 🌿',
};

export const ONBOARDING_LEVEL_LABELS = {
  beginner: 'Just Starting 🌱',
  moderate: 'Somewhat Active 🚶',
  fit: 'Pretty Fit 🏃',
  athlete: 'Very Athletic 🦅',
};

export const ONBOARDING_FREQUENCY_LABELS = {
  '2_3': '2–3× a week',
  '4_5': '4–5× a week',
  daily: 'Every day 🔥',
  flexible: 'Flexible 🎯',
};

export const ONBOARDING_ACTIVITY_LABELS = {
  run: '🏃 Run',
  yoga: '🧘 Yoga',
  gym: '💪 Gym',
  cycle: '🚴 Cycle',
  swim: '🏊 Swim',
  walk: '🚶 Walk',
  steps: '👟 Steps',
  other: '⚡ Other',
};

export const ONBOARDING_MOTIVATION_LABELS = {
  progress: 'Progress Tracking 📈',
  community: 'Moving With Others 🔥',
  accountability: 'Helpful Reminders 🔔',
  competition: 'Friendly Competition 🏆',
};

export const ONBOARDING_PRIVACY_LABELS = {
  sync_data: 'Workout Data Sync',
  manual_first: 'Manual Logging First',
  optional_data: 'Optional Health Sync 🔒',
};

export const ONBOARDING_DATA_SOURCE_LABELS = {
  manual: 'Manual Logging',
  apple_watch: 'Apple Watch',
  health_connect: 'Health Connect',
  garmin: 'Garmin',
  oura: 'Oura',
  other_health: 'Other Health Source',
};

export const ONBOARDING_HEALTH_SYNC_LABELS = {
  workouts_steps: 'Workouts + Steps Sync',
  advanced_later: 'Advanced Sync Later',
  manual_first: 'Manual Logging First',
  connect_later: 'Connect Watch Later',
};
